import { render, staticRenderFns } from "./informationDetail.vue?vue&type=template&id=27f05e66&scoped=true"
import script from "./informationDetail.vue?vue&type=script&lang=ts"
export * from "./informationDetail.vue?vue&type=script&lang=ts"
import style0 from "./informationDetail.vue?vue&type=style&index=0&id=27f05e66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f05e66",
  null
  
)

export default component.exports